import sliderHtml from './slider.html';
import './slider.scss';

class SliderDirective {
    constructor($window, $rootScope) {
        this.restrict = 'E';
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.template = sliderHtml;
        this.transclude = true;
        this.replace = true;
        this.controllerAs = '$ctrl';
        this.bindToController = true;
        this.controller = SliderDirectiveController;
        this.scope = {};
    }

    link(scope, element, attrs, controllers) {
        scope.sliderContentDom = element.find('div')[0];
        scope.id = attrs.id;
        scope.showButtons = true;
        scope.showList = false;
        scope.showBorders = true;
        scope.autoPlay = false;

        if (attrs.showList == 'true') {
            scope.showList = true;
        }

        if (attrs.showButtons == 'false') {
            scope.showButtons = false;
        }

        if (attrs.showBorders == 'false') {
            scope.showBorders = false;
        }

        if (attrs.autoPlay) {
            const value = parseInt(attrs.autoPlay);

            if (value > 0)
                scope.autoPlay = value;
        }

        if (!scope.id || scope.id == '')
            scope.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

        scope.contentDom = angular.element(scope.sliderContentDom).find('div')[0];
        
        const resetVariables = () => {
            scope.offset = 0;
            scope.containerWidth = scope.contentDom.clientWidth;
            scope.scrollWidth = scope.contentDom.scrollWidth;
            scope.maxOffset = Math.ceil(scope.scrollWidth / scope.containerWidth);
            scope.sliderContentDom.style.height = scope.containerHeight + 'px';
            scope.contentDom.style.left = '0px';

            this.baseWidth = this.$window.innerWidth > 768 ? 1920 : 1000;
            let scale = 'scale(' + this.$window.innerWidth / this.baseWidth + ')';
            let scaledContentWidth = this.$window.innerWidth <= 768 ? ((this.baseWidth / this.$window.innerWidth) * 100) + '%' : '';
            let scaledContent = scope.contentDom.getElementsByClassName('scaled-content');

            Array.from(scaledContent).forEach(object => {
                object.style.transform = scale;
                object.style.width = scaledContentWidth;
            });
        };
        
        resetVariables();

        setTimeout(resetVariables, 100);

        angular.element(this.$window).on('resize', resetVariables);

        this.$rootScope.$on('tabs-change', (event, id) => {
            resetVariables();
        });

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', resetVariables);
        });
    }

    static directiveFactory($window, $rootScope) {
        'ngInject';
        return new SliderDirective($window, $rootScope);
    }
}

class SliderDirectiveController {
    constructor($scope, $timeout) {
        'ngInject';
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.autoPlay = null;
    }

    $onInit() {
        this.$timeout(() => {
            this.startAutoPlay();
        }, 500);
    }

    onMouseEnter() {
        if (this.autoPlay) {
            this.$timeout.cancel(this.autoPlay);
            this.autoPlay = null;
        }
    }

    onMouseLeave() {
        this.startAutoPlay();
    }

    startAutoPlay() {
        if (!this.$scope.autoPlay) return;

        if (this.autoPlay) {
            this.$timeout.cancel(this.autoPlay);
            this.autoPlay = null;
        }

        this.autoPlay = this.$timeout(() => {
            if (this.$scope.offset >= this.$scope.maxOffset - 1) {
                this.change(0);
            } else {
                this.next();
            }

            this.startAutoPlay();
        }, this.$scope.autoPlay * 1000);
    }

    prev() {
        if (this.$scope.offset < 1) return;

        this.$scope.offset--;

        let value = this.$scope.containerWidth * this.$scope.offset;

        this.changePosition(value);
    }

    next() {
        if (this.$scope.offset >= this.$scope.maxOffset - 1) return;

        this.$scope.offset++;

        let value = this.$scope.containerWidth * this.$scope.offset;

        this.changePosition(value);
    }

    change(n) {
        this.$scope.offset = n;

        let value = this.$scope.containerWidth * this.$scope.offset;

        this.changePosition(value);
    }

    get range() {
        if (!this.$scope.maxOffset) return [];
        if (this.$scope.maxOffset < 1) return [];

        return Array.from(Array(this.$scope.maxOffset).keys());
    }

    changePosition(value) {
        let offset = 0;
        
        if (this.$scope.showBorders) {
            offset = 1;
        }

        angular.element(this.$scope.contentDom).css({left: (-value + offset) + 'px'});
    }
}

export default SliderDirective;
